import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useEllipsis } from './useEllipsis';
import { useConfigContext } from '../config';
var typeDefs = {
  maxLines: Number,
  disabled: Boolean,
  position: [Object, 'left', 'bottom', 'right', 'top'],
  theme: ['light', 'dark'],
  hoverable: Boolean
};
var defaults = function defaults() {
  return {
    disabled: false,
    theme: 'light',
    hoverable: false
  };
};
export var Ellipsis = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Ellipsis, _Component);
  function Ellipsis() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.ellipsis = useEllipsis();
    _this.config = useConfigContext();
    return _this;
  }
  return Ellipsis;
}(Component);
Ellipsis.template = template;
Ellipsis.typeDefs = typeDefs;
Ellipsis.defaults = defaults;